// src/utils/redirectManager.ts - SEO redirect utilities
export class RedirectManager {
  /**
   * Handle canonical redirects for SEO
   * This should be called early in the app initialization
   */
  static handleCanonicalRedirects(): void {
    const currentUrl = window.location;
    let shouldRedirect = false;
    let newUrl = '';

    // 1. Redirect www to non-www
    if (currentUrl.hostname.startsWith('www.')) {
      const nonWwwHostname = currentUrl.hostname.replace('www.', '');
      newUrl = `${currentUrl.protocol}//${nonWwwHostname}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
      shouldRedirect = true;
    }
    
    // 2. Remove trailing slashes except for root
    else if (currentUrl.pathname !== '/' && currentUrl.pathname.endsWith('/')) {
      const pathWithoutSlash = currentUrl.pathname.slice(0, -1);
      newUrl = `${currentUrl.protocol}//${currentUrl.hostname}${pathWithoutSlash}${currentUrl.search}${currentUrl.hash}`;
      shouldRedirect = true;
    }
    
    // 3. Force HTTPS in production only
    else if (import.meta.env.VITE_NODE_ENV === 'production' && currentUrl.protocol === 'http:' && currentUrl.hostname === 'strymhub.com') {
      newUrl = `https://${currentUrl.hostname}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
      shouldRedirect = true;
    }

    if (shouldRedirect && newUrl) {
      // Use replace to avoid adding to browser history
      window.location.replace(newUrl);
    }
  }

  /**
   * Clean URL parameters for canonical purposes
   */
  static cleanUrlParams(url: string): string {
    const urlObj = new URL(url);
    
    // Remove tracking parameters
    const trackingParams = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
      'fbclid', 'gclid', 'mc_cid', 'mc_eid', '_ga', 'ref', 'source'
    ];
    
    trackingParams.forEach(param => {
      urlObj.searchParams.delete(param);
    });
    
    return urlObj.toString();
  }

  /**
   * Generate canonical URL for any path
   */
  static getCanonicalUrl(path: string = ''): string {
    // Always use the canonical domain
    const baseUrl = 'https://strymhub.com';
    
    // Clean path
    let cleanPath = path.startsWith('/') ? path : `/${path}`;
    
    // Remove trailing slash except for root
    if (cleanPath !== '/' && cleanPath.endsWith('/')) {
      cleanPath = cleanPath.slice(0, -1);
    }
    
    return `${baseUrl}${cleanPath}`;
  }
}

export default RedirectManager;
